import moment from "moment";
import parse from "html-react-parser";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {getClassDetailsById} from "../../utils/reactQueries";

const BlockTeacherCreatePlan = () => {

    const [currentClass, _currentClass] = useState([]);

    const param = useParams();
    const classId = param.classId;

    const {status, data: classData, error: classError, isFetching} = getClassDetailsById(classId);
    const classes = classData?.data;

    useEffect(() => {
        if (classes) {
            _currentClass([classes]);
        }
    }, [classes]);

    const checkElementEmptyOrNot = () => {
        const detailsSection = document.getElementById('details');
        if (detailsSection?.textContent?.trim() === '') {
            return true;
        } else {
            return false;
        }
    }
    return (
      <>
        {currentClass?.map((vClass, index) => (
          <div className="mb-8 rounded-lg bg-[#F4F4F4]" key={index}>
            <div
              className={
                "w-full bg-[#F4F4F4] mx-auto rounded-lg text-left mb-0 text-lg flex flex-col"
              }
            >
              <div className="bg-white z-10">
                <div className="shadow z-10 rounded-lg p-2 text-sm flex flex-wrap justify-between items-center gap-3 p-3">
                  <div className="flex justify-center items-center flex-row">
                    <i className="text-zinc-400 icon icon-user text-2xl mr-0.5 md:mr-3"></i>
                    <span className="text-sm">{vClass?.title}</span>
                  </div>
                  <div className="flex justify-center items-center flex-row">
                    <i className="text-zinc-400 icon icon-book-open text-2xl mr-0.5 md:mr-3"></i>
                    <p className="truncate text-sm">{vClass?.subject?.title}</p>
                  </div>
                  <div className="flex justify-center items-center flex-row">
                    <i className="text-zinc-400 icon icon-clock text-2xl mr-0.5 md:mr-3"></i>
                    <span className="text-sm">
                      {moment.unix(vClass?.start_time).format("HH:mmA")}-
                      {moment
                        .unix(vClass?.start_time + vClass?.duration_seconds)
                        .format("HH:mmA")}
                    </span>
                  </div>
                  {/*<span className="grid grid-rows-1 lg:grid-cols-2 lg:grid-rows-1 flex-grow ">*/}
                  {/*    <span className="grid grid-cols-1 mt-1">*/}
                  {/*        <div className="flex justify-center items-center flex-row">*/}
                  {/*             <i className="text-zinc-400 icon icon-clock text-2xl mr-0.5 md:mr-3"></i>*/}
                  {/*            <span*/}
                  {/*                className="text-sm">Time-{moment.unix(vClass?.start_time).format("HH:mmA")}-{moment.unix(vClass?.start_time + vClass?.duration_seconds).format("HH:mmA")}</span>*/}
                  {/*        </div>*/}
                  {/*    </span>*/}
                  {/*    <span className="grid grid-cols-1 mt-1">*/}
                  {/*        <div className="flex justify-center items-center flex-row">*/}
                  {/*             <i className="text-zinc-400 icon icon-clock text-2xl mr-0.5 md:mr-3"></i>*/}
                  {/*            <span*/}
                  {/*                className="text-sm">Time-{moment.unix(vClass?.start_time).format("HH:mmA")}-{moment.unix(vClass?.start_time + vClass?.duration_seconds).format("HH:mmA")}</span>*/}
                  {/*        </div>*/}
                  {/*    </span>*/}
                  {/*    <span className="grid grid-cols-2 text-sm mt-1">*/}
                  {/*        <span className="mr-3  min-w-lg  text-sm md:text-lg flex items-center">*/}
                  {/*            <i className="text-zinc-400 icon icon-user text-2xl mr-0.5 md:mr-3"></i>*/}
                  {/*            <span className="text-sm">Class - {vClass?.title}</span>*/}
                  {/*        </span>*/}
                  {/*        <span className="mr-3 max-w-xs text-sm md:text-lg flex items-center">*/}
                  {/*            <i className="text-zinc-400 icon icon-book-open text-2xl mr-0.5 md:mr-3"></i>*/}
                  {/*            <p className="truncate text-sm">subject- {vClass?.subject?.title}</p>*/}
                  {/*        </span>*/}
                  {/*    </span>*/}
                  {/*    <span className="grid grid-cols-1 mt-1">*/}
                  {/*        <div className="flex justify-center items-center flex-row">*/}
                  {/*             <i className="text-zinc-400 icon icon-clock text-2xl mr-0.5 md:mr-3"></i>*/}
                  {/*            <span*/}
                  {/*                className="text-sm">Time-{moment.unix(vClass?.start_time).format("HH:mmA")}-{moment.unix(vClass?.start_time + vClass?.duration_seconds).format("HH:mmA")}</span>*/}
                  {/*        </div>*/}
                  {/*    </span>*/}
                  {/*</span>*/}
                </div>
              </div>
              <div className="text-gray-500 bg-[#F4F4F4] rounded-lg">
                <div className="px-3 py-1">
                  <div className="flex flex-row justify-between p-2">
                    <span className="text-md text-black">Details</span>
                  </div>
                  <div className="p-2">
                    <div
                      id="details"
                      className="text-sm text-black text-left pl-2"
                    >
                      {checkElementEmptyOrNot()
                        ? "NA"
                        : parse(vClass.description)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
};

export default BlockTeacherCreatePlan;
